<template>
  <button class="button" :class="{ 'button--disabled': hidden }">
   {{ title }}
  </button>
</template>

<script>
import MixinMediaQuery from "@/services/mixins/mediaQuery";

export default {
  name: "VButtonPessoalData",
  props: {
    title: String,
    hidden: Boolean
  },
  mixins: [MixinMediaQuery]
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.button {
  min-width: 30vw;
  min-height: 15vw;
  font-size: 4vw;

  @media #{$large-and-up} {
    font-size: 1.5vw;
    min-width: 4vw;
    min-height: 4vw;
  }
  padding: 16px 24px;
  border-radius: 8px;
  border: none;
  outline: none;
  background: #fff;
  box-shadow: 0px 8px 8px rgba(224, 224, 224, 0.2);
  color: #242424;
  &--disabled {
    visibility: hidden;
  }
}
</style>
